export default __webpack_public_path__ + "static/media/get_vip_okara.35fb80b1.svg";